import { MessageType } from '@/shared/api'
import {
  useAction,
  useNetworkErrorHandler,
  useServerErrorHandler,
} from '@/shared/config'

import { requestRoomReview as _requestRoomReview } from './request-room-review/request'

type Props = {
  onSuccess?: () => void
}

export const useRequestRoomReview = ({ onSuccess }: Props = {}) => {
  const { handleServerError } = useServerErrorHandler()
  const { handleNetworkError } = useNetworkErrorHandler()

  const action = useAction(_requestRoomReview, {
    onSuccess,
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const requestRoomReview = async (roomId: number) => {
    try {
      await action.executeAsync({ roomId })
    } catch (error) {
      handleNetworkError({
        error,
        type: MessageType.ALERT,
        title: '잠시 후 다시 시도해 주세요',
        content:
          '예기치 못한 오류가 발생했습니다.\n지속적으로 발생할 경우 고객센터로 문의해 주세요.',
        confirmText: '확인',
      })
    }
  }

  return { requestRoomReview }
}
